// Firebase core and services
import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeAuth, getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, updateProfile, sendPasswordResetEmail } from 'firebase/auth';
import { getFirestore, doc, setDoc, serverTimestamp, addDoc, collection, initializeFirestore, memoryLocalCache } from 'firebase/firestore';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Your config (provided by user)
const firebaseConfig = {
  apiKey: 'AIzaSyDS0giRaKNZCqUS3QVeglEoG2jI6xvsxmI',
  authDomain: 'bet-optimized-fe922.firebaseapp.com',
  projectId: 'bet-optimized-fe922',
  storageBucket: 'bet-optimized-fe922.appspot.com',
  messagingSenderId: '726893409427',
  appId: '1:726893409427:web:063b7dcffa255f1ccbc966',
  measurementId: 'G-64THM916HX',
};

// Initialize app (singleton)
let app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Auth: native/web safe initialization
let auth;
if (typeof window === 'undefined') {
  // Native/Node environment
  try {
    auth = initializeAuth(app, { persistence: undefined });
  } catch (e) {
    auth = getAuth(app);
  }
} else {
  // Web – use default web persistence
  auth = getAuth(app);
}

// Initialize Firestore with memory-only cache to avoid IndexedDB issues
// This prevents "Target ID already exists" errors from corrupted IndexedDB
let db;
if (typeof window !== 'undefined') {
  // Web: Use memory-only cache to prevent IndexedDB corruption and duplicate listener errors
  try {
    db = initializeFirestore(app, {
      localCache: memoryLocalCache()
    });
    console.log('✅ Firestore initialized with memory cache');
  } catch (error) {
    // If already initialized, use existing instance
    console.log('Firestore already initialized, using existing instance');
    db = getFirestore(app);
  }
} else {
  // Native/Node: Use default persistence
  db = getFirestore(app);
}

// Ensure a users/{uid} document exists with matching UID
async function ensureUserDocument(uid, data = {}) {
  const userRef = doc(db, 'users', uid);
  await setDoc(userRef, { uid, createdAt: serverTimestamp(), ...data }, { merge: true });
  return userRef;
}

// Email/password registration helper
export async function registerWithEmail(email, password, profile = {}) {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  if (profile.displayName) {
    try { await updateProfile(cred.user, { displayName: profile.displayName }); } catch {}
  }
  await ensureUserDocument(cred.user.uid, { email, ...profile });
  return cred.user;
}

// Email/password sign in helper (will not recreate doc)
export async function signInWithEmailHelper(email, password) {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  await ensureUserDocument(cred.user.uid, { email });
  return cred.user;
}

// Send password reset email
export async function sendPasswordReset(email, actionCodeSettings = {}) {
  const defaultSettings = {};
  try {
    if (typeof window !== 'undefined' && window?.location?.origin) {
      defaultSettings.url = window.location.origin + '/login';
    }
  } catch {}
  const settings = { ...defaultSettings, ...actionCodeSettings };
  await sendPasswordResetEmail(auth, email, Object.keys(settings).length ? settings : undefined);
  return true;
}

// Email capture helper
export async function saveEmailCapture(email) {
  const ref = await addDoc(collection(db, 'emailCaptures'), {
    email,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

export { app, auth, db, onAuthStateChanged };


